import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import he from './he.json';
import en from './en.json';

/**
 * Hebrew-first i18n (design §5): default `he`, English fallback, choice persisted in
 * localStorage. `setLanguage` also flips the document direction so RTL applies globally.
 */
const stored = (() => {
  try {
    return localStorage.getItem('lang');
  } catch {
    return null;
  }
})();

i18n.use(initReactI18next).init({
  resources: { he: { translation: he }, en: { translation: en } },
  lng: stored === 'en' ? 'en' : 'he',
  fallbackLng: 'en',
  interpolation: { escapeValue: false }, // React already escapes
});

export const dirFor = (lang) => (lang === 'he' ? 'rtl' : 'ltr');

export const applyDocumentLanguage = (lang) => {
  document.documentElement.lang = lang;
  document.documentElement.dir = dirFor(lang);
};

export const setLanguage = (lang) => {
  i18n.changeLanguage(lang);
  try {
    localStorage.setItem('lang', lang);
  } catch {
    // localStorage unavailable (private mode) — language just won't persist.
  }
  applyDocumentLanguage(lang);
};

applyDocumentLanguage(i18n.language);

export default i18n;
